<script>
  /**
   * Two dashed lines crossing at (medianX, medianY). Position is reactive
   * to the year (medians change). Pure SVG, no D3 mutations.
   */
  let { xScale, yScale, innerW, innerH, medianX, medianY } = $props();

  const cx = $derived(xScale(medianX));
  const cy = $derived(yScale(medianY));
</script>

<g class="quadrants">
  <line class="quadrant-line" x1={cx} x2={cx} y1="0" y2={innerH} />
  <line class="quadrant-line" x1="0" x2={innerW} y1={cy} y2={cy} />
</g>
